<div class="row no-gutters mt-3" *ngIf="user.isVerified">
    <div class="col text-right">
        <button id="{{ idPrefix }}.twoFa.sms.btn.reset" 
                mat-flat-button
                (click)="reset(AuthenticationMethods.SMS)"
        >
            {{ 'user_management.2fa.btn.reset' | translate | uppercase }}
        </button>
    </div>
</div>

<div class="mt-3">

    <p *ngIf="!user.isVerified">{{ 'user_management.2fa.phone_number_verification_text' | translate }}</p>

    <div class="row">
        <div class="col-lg-5 col-md-6 col-sm-12">
            <mat-form-field class="full-width">
                <mat-label>{{ 'user_management.2fa.phone_number.placeholder' | translate }}</mat-label>
                <input id="{{ idPrefix }}.twoFA.sms.input.phone_number"
                       type="tel" matInput [only-digits]="['+']"
                       [(ngModel)]="user.authentication_sms_phonenumber"
                       [disabled]="user.isVerified">
            </mat-form-field>
        </div>

        <div class="col-lg-7 col-md-6 col-sm-12">
            <button id="{{ idPrefix }}.twoFa.sms.btn.sendCode" 
                    mat-flat-button
                    color="accent"
                    style="height: 48px;margin-top: 5px;"
                    [disabled]="user.isVerified || !user.authentication_sms_phonenumber"
                    (click)="sendVerificationCode(user.authentication_sms_phonenumber)"
            >
                {{ 'user_management.2fa.btn.send_code' | translate | uppercase }}
            </button>
        </div>
    </div>

    <div class="mt-3" *ngIf="!user.isVerified && showCodeVerifySection">
        <p>{{ 'user_management.2fa.verification_code_text' | translate }}</p>
        
        <form (ngSubmit)="verifyOTP(AuthenticationMethods.SMS, tan)" *ngIf="showCodeVerifySection">
            <div class="row">
                <div class="col-lg-5 col-md-6 col-sm-12">
                    <mat-form-field class="full-width">
                        <mat-label>{{ 'user_management.2fa.code.placeholder' | translate }}</mat-label>
                        <input id="{{ idPrefix }}.twoFA.sms.input.code"
                            type="tel" matInput
                            name="code"
                            autocomplete="off"
                            [(ngModel)]="tan">
                    </mat-form-field>
                </div>
        
                <div class="col-lg-7 col-md-6 col-sm-12">
                    <button id="{{ idPrefix }}.twoFa.sms.btn.verifyCode" 
                            mat-flat-button
                            color="accent"
                            style="height: 48px;margin-top: 5px;"
                            type="submit"
                            [disabled]="!tan"
                    >
                        {{ 'user_management.2fa.btn.verify' | translate | uppercase }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
